import {decodeBase64ToJson} from '../../utils/functions/Functions';

async function getDecodedResponse(response) {
  const result = await response.json();
  if (result?.encodedResponse !== undefined){
    return decodeBase64ToJson(result.encodedResponse);
  }
  return result;
}

export function submitApplication(reCaptchaToken,customerData, appConfig) {
  const submitAppData = mapForSubmit(reCaptchaToken,customerData, appConfig);
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'UUID': customerData.uuid,
      'Source': customerData.prequalSource.value,
      'Path': window.location.pathname,
      'CountryCode': customerData.countryCode.value,
      'LanguageCode': customerData.languageCode
    },
    body: JSON.stringify(submitAppData)
  };
  const submitUrl = appConfig.exrServiceApi + appConfig.submitAppPath;
  return fetch(submitUrl, requestOptions)
    .then(async (response) => getDecodedResponse(response))
    .catch((response) => response.json());
}

/* postalCode value for canadian submissions to risk cannot have dashes, but usa submissions with 9-digit postalCode's need dashes */
function mapForSubmit(reCaptchaToken,customerData, appConfig) {
  function getApartment() {
    if(!appConfig.modalUpdateFlag){
      return customerData.apartment?.value ? customerData.apartment?.value.trim() : '';
    }
    return '';
  }

  return {
    firstName: customerData.firstName.value.trim(),
    lastName: customerData.lastName.value.trim(),
    dateOfBirth: new Date(
      +customerData.dateOfBirth.year.value,
      customerData.dateOfBirth.month.value - 1,
      +customerData.dateOfBirth.day.value
    ),
    homeAddress: {
      streetAddress: customerData.streetAddress.value.trim(),
      apartment: getApartment(),
      city: customerData.city.value.trim(),
      stateOrProvince: customerData.stateOrProvince.value,
      postalCode: customerData.countryCode.value === 'CAN' ? customerData.postalCode.value.replace(' ', '').replace('-','') : customerData.postalCode.value,
    },
    income: parseFloat(customerData.income.value),
    email: customerData.email.value.trim(),
    dealerId: customerData.tier3PACode?.value ? customerData.tier3PACode.value : null,
    vin: customerData.tier3Vin?.value ? customerData.tier3Vin.value : null,
    reCaptchaValue: reCaptchaToken,
    isOptimizelyEnabledForRecaptcha: customerData?.recaptchaOptimizelyData?.variationKey==='treatment'
  };
}
